<div class="modal-header" id="confirmation-summary-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_SUMMARY_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <fieldset [formGroup]="confirmationSummaryForm" [disabled]="isLoading">
        <div class="row mb-3">
            @if (!model.confirmationModel.timeRecording.isNotificationRemoteWork) {
                <div class="col-12 col-lg-6">
                    @if (model.timeRecordingTravelToFirstEntry) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryTripToWithStandby"
                                translate="CONFIRMATION_SUMMARY_TRIP_TO_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryTripToWithStandby">
                                <span class="form-control-plaintext px-0">
                                    {{
                                        formatEntry(
                                            model.timeRecordingTravelToFirstEntry,
                                            model.timeRecordingTravelToLastEntry
                                        )
                                    }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.timeRecordingTravelToDuration) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingPhoneFixEntry) {
                        <div class="row">
                            <label class="col-12 col-lg-3 col-form-label text-start text-lg-end" for="summaryPhoneFix">
                                {{ model.timeRecordingPhoneFixEntry.typeOfWorkModel.selectedEntry.displayName }}</label
                            >
                            <div class="col-12 col-lg-auto" id="summaryPhoneFix">
                                <span class="form-control-plaintext px-0">
                                    {{ formatEntry(model.timeRecordingPhoneFixEntry) }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.timeRecordingPhoneFixDuration) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    <!--Aggregated Work entry display for NGMP58-->
                    @if (model.timeRecordingOnsiteFirstEntry) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryWork"
                                translate="CONFIRMATION_SUMMARY_WORK_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryWork">
                                <span class="form-control-plaintext px-0">
                                    {{
                                        formatEntry(
                                            model.timeRecordingOnsiteFirstEntry,
                                            model.timeRecordingOnsiteLastEntry
                                        )
                                    }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.timeRecordingOnsiteDuration) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    <!--Individual Work entries display for NGMAA-->
                    @for (entry of model.timeRecordingOnsiteEntriesList; track trackById(i, entry); let i = $index) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryWork_{{ i }}"
                                translate="CONFIRMATION_SUMMARY_WORK_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryWork_{{ i }}">
                                <span class="form-control-plaintext px-0">
                                    {{ formatEntry(entry, entry) }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.calculateTotalDuration([entry])) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingWaitDuration) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryWait"
                                translate="CONFIRMATION_SUMMARY_WAIT_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryWait">
                                <span class="form-control-plaintext px-0">
                                    {{ formatDuration(model.timeRecordingWaitDuration) }}
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingTravelBackFirstEntry && displayTravelBackSummary) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryTripBack"
                                translate="CONFIRMATION_SUMMARY_TRIP_BACK_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryTripBack">
                                <span class="form-control-plaintext px-0">
                                    {{
                                        formatEntry(
                                            model.timeRecordingTravelBackFirstEntry,
                                            model.timeRecordingTravelBackLastEntry
                                        )
                                    }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.timeRecordingTravelBackDuration) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingBreakDuration) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryBreak"
                                translate="CONFIRMATION_SUMMARY_BREAK_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="summaryBreak">
                                <span class="form-control-plaintext px-0">
                                    {{ formatDuration(model.timeRecordingBreakDuration) }}
                                </span>
                            </div>
                        </div>
                    }
                    @if (selfAssignedTaskOriginalPlannedDate) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="originalPlannedDate"
                                translate="CONFIRMATION_SUMMARY_ORIGINALLY_PLANNED_DATE_LABEL"
                            ></label>
                            <div class="col-12 col-lg-auto" id="originalPlannedDate">
                                <span class="form-control-plaintext px-0">{{
                                    formatDateTime(selfAssignedTaskOriginalPlannedDate)
                                }}</span>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (model.confirmationModel.timeRecording.isNotificationRemoteWork) {
                <div class="col-12 col-lg-8">
                    @if (model.timeRecordingRemoteWorkFirstEntry) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end pe-0"
                                for="summaryRemoteWork"
                                >{{ remoteWorkLabel }}</label
                            >
                            <div class="col-12 col-lg-9" id="summaryRemoteWork">
                                <span class="form-control-plaintext px-0">
                                    {{
                                        formatEntry(
                                            model.timeRecordingRemoteWorkFirstEntry,
                                            model.timeRecordingRemoteWorkLastEntry
                                        )
                                    }}
                                    <span class="d-inline d-lg-block">
                                        | {{ formatDuration(model.timeRecordingRemoteWorkDuration) }}</span
                                    >
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingBreakDuration) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryRemoteBreak"
                                translate="CONFIRMATION_SUMMARY_BREAK_LABEL"
                            ></label>
                            <div class="col-12 col-lg-9" id="summaryRemoteBreak">
                                <span class="form-control-plaintext px-0">
                                    {{ formatDuration(model.timeRecordingBreakDuration) }}
                                </span>
                            </div>
                        </div>
                    }
                    @if (model.timeRecordingWaitDuration) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-3 col-form-label text-start text-lg-end"
                                for="summaryRemoteWait"
                                translate="CONFIRMATION_SUMMARY_WAIT_LABEL"
                            ></label>
                            <div class="col-12 col-lg-9" id="summaryRemoteWait">
                                <span class="form-control-plaintext px-0">
                                    {{ formatDuration(model.timeRecordingWaitDuration) }}
                                </span>
                            </div>
                        </div>
                    }
                </div>
            }
            <div class="col-12 col-lg-4">
                <div class="row">
                    <label
                        class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                        for="summaryRecovery"
                        translate="CONFIRMATION_SUMMARY_SYSTEM_RECOVERY_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryRecovery">
                        <span class="form-control-plaintext px-0"> {{ formatDateTime(model.recoveryDateTime) }} </span>
                    </div>
                </div>
                @if (displayDistance) {
                    <div class="row">
                        <label
                            class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                            for="summaryDistance"
                            translate="CONFIRMATION_SUMMARY_DISTANCE_LABEL"
                        ></label>
                        <div class="col-12 col-lg-auto" id="summaryDistance">
                            <span class="form-control-plaintext px-0">
                                {{ confirmationModel.expenses.distance.value }}
                                <span translate="CONFIRMATION_EXPENSES_KM_LABEL"></span>
                            </span>
                        </div>
                    </div>
                }
                <div class="row">
                    <label
                        class="col-12 col-lg-6 col-form-label text-start text-lg-end"
                        for="summaryFollowUp"
                        translate="CONFIRMATION_SUMMARY_FOLLOWUP_LABEL"
                    ></label>
                    <div class="col-12 col-lg-auto" id="summaryFollowUp">
                        <span class="form-control-plaintext px-0"> {{ followUpSelectedEntry }} </span>
                    </div>
                </div>
            </div>
        </div>

        @if (
            confirmationModel.followup?.showLegalCheckHandover &&
            confirmationModel.followup?.followupOptions.selectedEntry.value === optionValueNo
        ) {
            <div class="row mb-3">
                <div class="col-12 offset-lg-6 col-lg-6">
                    <div class="row">
                        <label
                            class="col-12 col-lg-8 col-form-label text-start text-lg-end"
                            for="summaryHandoverSafetyInfo"
                            >{{ confirmationModel.followup.legalCheckHandoverSafetyInformationText }}</label
                        >
                        <div class="col-12 col-lg-4" id="summaryHandoverSafetyInfo">
                            <span class="form-control-plaintext px-0">
                                {{
                                    confirmationModel.followup.legalCheckHandoverSafetyInformation.selectedEntry
                                        .displayName
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <label
                            class="col-12 col-lg-8 col-form-label text-start text-lg-end"
                            for="summaryHandoverUserDoc"
                            >{{ confirmationModel.followup.legalCheckHandoverUserDocumentationText }}</label
                        >
                        <div class="col-12 col-lg-4" id="summaryHandoverUserDoc">
                            <span class="form-control-plaintext px-0">
                                {{
                                    confirmationModel.followup.legalCheckHandoverUserDocumentation.selectedEntry
                                        .displayName
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        }
        <!-- row -->
        @if (confirmationModel.measurementTool?.showLegalCheckVerification) {
            <div class="row mb-3">
                @if (
                    confirmationModel.measurementTool.legalCheckVerifiedSecurityDevice.selectedEntry.value ===
                    optionValueYes
                ) {
                    <label class="col-12 col-lg-10 col-form-label text-start text-lg-end">
                        {{ confirmationModel.measurementTool.legalCheckVerifiedSecurityDeviceText }}
                    </label>
                    <div class="col-12 col-lg-2">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.measurementTool.legalCheckVerifiedSecurityDevice.selectedEntry
                                    .displayName
                            }}
                        </span>
                    </div>
                }
                @if (
                    confirmationModel.measurementTool.legalCheckResumptionAfterUserValidation.selectedEntry.value ===
                    optionValueYes
                ) {
                    <label class="col-12 col-lg-10 col-form-label text-start text-lg-end">
                        {{ confirmationModel.measurementTool.legalCheckResumptionAfterUserValidationText }}
                    </label>
                    <div class="col-12 col-lg-2">
                        <span class="form-control-plaintext px-0">
                            {{
                                confirmationModel.measurementTool.legalCheckResumptionAfterUserValidation.selectedEntry
                                    .displayName
                            }}
                        </span>
                    </div>
                }
            </div>
        }
        <!-- row -->
        @if (affectedEquipment) {
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    for="affectedEquipment"
                    translate="CONFIRMATION_SUMMARY_AFFECTED_EQUIPMENT_LABEL"
                ></label>
                <div class="col-12 col-lg-8" id="affectedEquipment">
                    <span class="form-control-plaintext px-0">{{ affectedEquipment }}</span>
                </div>
            </div>
        }
        <!-- row -->
        <ng-container>
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_REPORT_CODE_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <span class="form-control-plaintext px-0">{{ model.reportCodes }}</span>
                </div>
            </div>
        </ng-container>
        <ng-container>
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_REPORT_TEXT_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <div class="form-control-plaintext px-0 new-line-wrapper">{{ model.reportText?.value }}</div>
                </div>
            </div>
        </ng-container>
        @if (model.recipients.length > 0) {
            <hr />
            <div class="row mb-3">
                <label
                    for="recipients"
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    [translate]="'CONFIRMATION_SUMMARY_RECIPIENTS_TEXT_LABEL'"
                ></label>
                <div class="col-12 col-lg-8" id="recipients">
                    @for (recipient of model.recipients; track recipient) {
                        <div>
                            <span class="form-control-plaintext">{{ recipient }}</span>
                        </div>
                    }
                </div>
            </div>
        }
        <!-- row -->
        @if (confirmationModel.equipment?.phiDataCode && confirmationModel.equipment?.phiDataCode.selectedEntry) {
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_PHI_DATA_CODE_LABEL"
                ></label>
                <div class="col-12 col-lg-8">
                    <span class="form-control-plaintext px-0">
                        {{ confirmationModel.equipment.equipmentNr.value }} -
                        {{ confirmationModel.equipment.equipments.selectedEntry.displayName }} -
                        {{ confirmationModel.equipment.phiDataCode.selectedEntry.displayName }}
                    </span>
                </div>
            </div>
        }
        @if (model.additionalExpensesText) {
            <hr />
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_EXPENSES_LABEL"
                ></label>
                <div class="col-12 col-lg-10" id="additionalExpenses">
                    <span class="form-control-plaintext px-0"> {{ model.additionalExpensesText }} </span>
                </div>
            </div>
        }
        @if (model.isMaterialTaxiBillable()) {
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    translate="CONFIRMATION_SUMMARY_MATERIAL_LABEL"
                ></label>
                <div class="col-12 col-lg-10" id="additionalTaxiCost">
                    <span
                        class="form-control-plaintext px-0"
                        translate="CONFIRMATION_MATERIAL_TAXI_ADDITIONAL_COST"
                    ></span>
                </div>
            </div>
        }
        @if (isShortConfirmation && displayMaterial) {
            <pace-confirmation-summary-material
                [materials]="model.summaryMaterial"
            ></pace-confirmation-summary-material>
        }
        <!-- For short confirmation, contact person and signature is not required.-->
        @if (!isShortConfirmation) {
            <hr />
            <div class="row">
                <div class="col-12">
                    @if (model.confirmationModel.uploadToDocBox?.documentTitle.length > 0) {
                        <div class="row">
                            <label
                                class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                                for="uploadedToDocBox"
                                translate="CONFIRMATION_UPLOADED_TO_DOCBOX_LABEL"
                            ></label>
                            <div class="col-12 col-lg-8" id="uploadedToDocBox">
                                @for (
                                    docTitle of model.confirmationModel.uploadToDocBox.documentTitle;
                                    track docTitle
                                ) {
                                    <div>
                                        <span class="form-control-plaintext px-0"> {{ docTitle }} </span>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    @if (displayMaterial) {
                        <pace-confirmation-summary-material
                            [materials]="model.summaryMaterial"
                        ></pace-confirmation-summary-material>
                    }
                    @if (displayParticipants) {
                        <pace-confirmation-summary-participants
                            [participants]="model.summaryParticipants"
                            [displayMobileNumber]="displayMobileNumber"
                        ></pace-confirmation-summary-participants>
                    }
                    <pace-confirmation-summary-measurement-tools
                        [displayMeasurementTool]="displayMeasurementTool"
                        [measurementTools]="model.measurementTools"
                        [displayMeasurementToolDetails]="displayMeasurementToolDetails"
                        [measurementToolsDetailsList]="model.measurementToolsDetailsList"
                        [measurementToolsEmptyMessage]="measurementToolsEmptyMessage"
                        [radioActiveToolMessage]="radioActiveToolsUsedMessage"
                    ></pace-confirmation-summary-measurement-tools>
                </div>
            </div>
            <hr />
            @if (displayCustomerInformation) {
                <div>
                    <div class="row">
                        <div class="col-12">
                            <h4 translate="CONFIRMATION_SUMMARY_CUSTOMER_INFORMATION_TITLE"></h4>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <label
                                    class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                    for="functional-location"
                                    translate="CONFIRMATION_SUMMARY_FUNCTIONAL_LOCATION_LABEL"
                                ></label>
                                <div class="col-12 col-lg-8" id="functional-location">
                                    <span class="form-control-plaintext px-0"> {{ notification.functionalLoc }} </span>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                    for="customer-name"
                                    translate="CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL"
                                ></label>
                                <div class="col-12 col-lg-8" id="customer-name">
                                    <span class="form-control-plaintext px-0">
                                        {{ notification.address.completeName }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                    for="notification-number"
                                    translate="CONFIRMATION_SUMMARY_NOTIFICATION_NUMBER_LABEL"
                                ></label>
                                <div class="col-12 col-lg-8" id="notification-number">
                                    <span class="form-control-plaintext px-0">
                                        {{ notification.identifier.qmNum }} ({{ notification.identifier.maNum }})
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <label
                                    class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                    for="main-equipment-name"
                                    translate="CONFIRMATION_SUMMARY_MAIN_EQUIPMENT_NAME_LABEL"
                                ></label>
                                <div class="col-12 col-lg-8" id="main-equipment-name">
                                    <span class="form-control-plaintext px-0">
                                        {{ notification.getMainEquipment()?.equiShortDesc.value }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    class="col-12 col-lg-4 col-form-label text-start text-lg-end"
                                    for="main-equipment-number"
                                    translate="CONFIRMATION_SUMMARY_MAIN_EQUIPMENT_NUMBER_LABEL"
                                ></label>
                                <div class="col-12 col-lg-8" id="main-equipment-number">
                                    <span class="form-control-plaintext px-0">
                                        {{ notification.getMainEquipment()?.equnr.value }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div class="row mb-3 mt-lg-5">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    for="customerName"
                    translate="CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL"
                ></label>
                <div class="col-12 col-lg-4">
                    <pace-core-text-input
                        id="customerName"
                        [(model)]="model.customerName"
                        [parentForm]="confirmationSummaryFormChildren"
                        [ariaLabel]="'CONFIRMATION_SUMMARY_CUSTOMER_NAME_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            </div>
            @if (displayCustomerContact) {
                <div class="row mb-3 mt-lg-5">
                    <label
                        class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                        for="customerContact"
                        translate="CONFIRMATION_SUMMARY_CUSTOMER_CONTACT_LABEL"
                    ></label>
                    <div class="col-12 col-lg-4">
                        <pace-core-text-input
                            [(model)]="model.customerContact"
                            [ariaLabel]="'CONFIRMATION_SUMMARY_CUSTOMER_CONTACT_LABEL' | translate"
                            [parentForm]="confirmationSummaryFormChildren"
                            id="customerContact"
                        >
                        </pace-core-text-input>
                    </div>
                </div>
            }
            @if (!!model.customerAgreementTextClause) {
                <div class="row mb-3">
                    <div class="col-12 offset-lg-2 col-lg-8">
                        <span class="form-control-plaintext px-0 new-line-wrapper">{{
                            model.customerAgreementTextClause
                        }}</span>
                    </div>
                </div>
            }
            <div class="mb-3">
                <div class="row mb-3 mt-lg-5">
                    @if (displayCustomerSignature) {
                        <label
                            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                            for="customerSignature"
                            translate="CONFIRMATION_SUMMARY_SIGNATURE_LABEL"
                        ></label>
                        <div class="col-12 col-lg-4" [ngClass]="{ 'no-pointer-events': isLoading }">
                            <canvas
                                #customerSignatureCanvasElement
                                class="signature-canvas w-100"
                                [ngClass]="{
                                    'ng-dimmed': model.customerNotAvail.value,
                                    'ng-invalid':
                                        customerSignaturePad &&
                                        customerSignaturePad.isEmpty &&
                                        !model.customerNotAvail.value,
                                }"
                                id="customerSignature"
                            ></canvas>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-start align-items-center d-lg-none">
                            <pace-core-checkbox-input
                                (valueChange)="customerNotAvailChanged()"
                                [(model)]="model.customerNotAvail"
                                [parentForm]="confirmationSummaryFormChildren"
                                class="me-3"
                            >
                            </pace-core-checkbox-input>
                            <button
                                type="button"
                                class="btn btn-secondary"
                                (click)="clearCustomerSignature()"
                                translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                            ></button>
                        </div>
                    }
                    @if (displayCseSignature) {
                        <label
                            class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                            for="cseSignature"
                            translate="CONFIRMATION_SUMMARY_CSE_SIGNATURE_LABEL"
                        ></label>
                        <div class="col-12 col-lg-4" [ngClass]="{ 'no-pointer-events': isLoading }">
                            <canvas
                                #cseSignatureCanvasElement
                                class="signature-canvas w-100"
                                [ngClass]="{ 'ng-invalid': cseSignaturePad && cseSignaturePad.isEmpty }"
                                id="cseSignature"
                            ></canvas>
                        </div>
                    }
                </div>
            </div>
            <div class="row mt-2">
                @if (displayCustomerSignature) {
                    <div class="col-lg-6 d-flex justify-content-end align-items-lg-start d-none d-lg-flex">
                        <pace-core-checkbox-input
                            [(model)]="model.customerNotAvail"
                            [parentForm]="confirmationSummaryFormChildren"
                            (valueChange)="customerNotAvailChanged()"
                            class="me-4"
                        >
                        </pace-core-checkbox-input>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            (click)="clearCustomerSignature()"
                            translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                        ></button>
                    </div>
                }
                @if (displayCseSignature) {
                    <div class="col-lg-6 d-flex justify-content-md-start justify-content-lg-end align-items-center">
                        <button
                            type="button"
                            class="btn btn-secondary float-end"
                            (click)="clearCseSignature()"
                            translate="CONFIRMATION_SUMMARY_CLEAR_LABEL"
                        ></button>
                    </div>
                }
            </div>
        }
    </fieldset>
</div>
<div class="modal-footer">
    @if (!isShortConfirmation && !isLoading) {
        <button
            class="btn btn-primary"
            type="button"
            [disabled]="confirmationSummaryForm.invalid"
            (click)="confirmSignatures()"
            translate="CONFIRMATION_SUMMARY_SUBMIT_CONFIRMATION_REPORT_LABEL"
        ></button>
    }
    @if (isShortConfirmation && !isLoading) {
        <button
            class="btn btn-primary"
            type="button"
            (click)="submit()"
            translate="CONFIRMATION_SUMMARY_SUBMIT_SHORT_CONFIRMATION_LABEL"
        ></button>
    }
    @if (isLoading) {
        <progressbar type="default" [value]="100">
            {{ 'CONFIRMATION_SUMMARY_PROGRESSBAR_LABEL' | translate }}
        </progressbar>
    }
</div>
